<template>
    <div id="admin-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered ref="modal-serv" scrollable :title="titleModal">
            <form id="formCrud" class="animated fadeIn margin-al-inputs">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="admin.currentName">
                    <input type="hidden" name="currentEmail" v-model="admin.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="admin.currentUserName">
                </div>
                <div class="row">

                    <div class="col-md-4 col-xl-2 offset-xl-1">
                        <input type="text" class="al-inputs required scr-input" v-model="admin.name"
                               placeholder="Nombre" id="ad-nombre">
                        <label for="ad-nombre" class="scr-supertext scr-extra">Nombre</label>
                    </div>
                    <div class="col-md-4 col-xl-2">
                        <input type="email" class="al-inputs required scr-input" v-model="admin.email"
                               placeholder="Correo" id="ad-correo">
                        <label for="ad-correo" class="scr-supertext scr-extra">Correo</label>
                    </div>
                    <div class="col-md-4 col-xl-2">
                        <input type="text" class="al-inputs required scr-input" v-model="admin.username"
                               placeholder="Usuario" id="ad-usuario">
                        <label for="ad-usuario" class="scr-supertext scr-extra">Usuario</label>
                    </div>
                    <div class="col-md-4 col-xl-2">
                        <input type="password" class="al-inputs required scr-input" v-model="admin.password"
                               placeholder="Password" id="ad-password">
                        <label for="ad-password" class="scr-supertext scr-extra">Password</label>
                    </div>
                    <div class="col-md-4 col-xl-2">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">
                            {{ tituloBtn }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">

            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                       <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                      :total-rows="pagination.total" :per-page="pagination.per_page"
                                      aria-controls="my-table" v-on:change="onChange"></b-pagination>
                    </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">
                                {{ tituloBtn }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" class="col-12">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(Nombre)="{item}">
                                {{ item.name }}
                            </template>
                            <template #cell(E-mail)="{item}">
                                {{ item.email }}
                            </template>
                            <template #cell(Username)="{item}">
                                {{ item.username }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {adminsService} from "../../Services/Admins.service";

export default {
    name: "admin",
    mixins: [myMixins],
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            admin: {
                id: 0,
                name: '',
                email: '',
                username: '',
                password: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            fields: [
                {
                    key: 'Nombre',
                    sortable: false
                },
                {
                    key: 'E-mail',
                    sortable: false
                },
                {
                    key: 'Username',
                    sortable: false
                },
                {
                    key: 'Acciones',
                    sortable: false
                }
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            tituloBtn: 'Agregar'
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await adminsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3();
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await adminsService.updateOne(this.admin.id, this.admin);
                } else {
                    resp = await adminsService.saveOne(this.admin);
                }
                this.modificar = false;
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.pagination = await adminsService.getMany(this.params);
            this.isBusy = false;
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar';
                this.admin = data;
                this.admin.currentName = data.name;
                this.admin.currentEmail = data.email;
                this.admin.currentUserName = data.username;
                this.admin.username = data.username
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.admin = {
                id: 0,
                name: '',
                email: '',
                username: '',
                password: '',
            };
        }
    },
    mounted() {
        this.index();
    }
}
</script>
